
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Navigation from '../../components/feature/Navigation';
import Card from '../../components/base/Card';
import Input from '../../components/base/Input';
import { countries } from '../../mocks/countries';

export default function Countries() {
  const [searchTerm, setSearchTerm] = useState('');
  const [filter, setFilter] = useState('all');

  const filteredCountries = countries.filter(country => {
    const matchesSearch = country.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = filter === 'all' || 
      (filter === 'hague' && country.hagueConvention) ||
      (filter === 'non-hague' && !country.hagueConvention);
    
    return matchesSearch && matchesFilter;
  });

  const hagueCount = countries.filter(c => c.hagueConvention).length;
  const nonHagueCount = countries.filter(c => !c.hagueConvention).length;

  return (
    <div className="min-h-screen bg-gray-50">
      <Header title="Countries" />
      
      <div className="pt-16 pb-20 px-4">
        {/* Stats */}
        <div className="grid grid-cols-3 gap-4 mb-6">
          <Card className="p-3">
            <div className="text-center">
              <div className="text-lg font-bold text-blue-600">{countries.length}</div>
              <div className="text-xs text-gray-600">Total</div>
            </div>
          </Card>
          <Card className="p-3">
            <div className="text-center">
              <div className="text-lg font-bold text-green-600">{hagueCount}</div>
              <div className="text-xs text-gray-600">Hague</div>
            </div>
          </Card>
          <Card className="p-3">
            <div className="text-center">
              <div className="text-lg font-bold text-red-600">{nonHagueCount}</div>
              <div className="text-xs text-gray-600">Non-Hague</div>
            </div>
          </Card>
        </div>

        {/* Search */}
        <div className="mb-4">
          <Input
            value={searchTerm}
            onChange={setSearchTerm}
            placeholder="Search countries..."
          />
        </div>

        {/* Filter Tabs */}
        <div className="flex space-x-1 mb-6 bg-gray-100 p-1 rounded-lg">
          {[
            { key: 'all', label: 'All Countries' },
            { key: 'hague', label: 'Hague Convention' },
            { key: 'non-hague', label: 'Non-Hague' }
          ].map((tab) => (
            <button
              key={tab.key}
              onClick={() => setFilter(tab.key)}
              className={`flex-1 px-3 py-2 text-xs font-medium rounded-md transition-colors ${
                filter === tab.key
                  ? 'bg-white text-blue-600 shadow-sm'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Countries List */}
        <div className="space-y-2">
          {filteredCountries.map((country) => (
            <Card key={country.code} className="p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
                    <span className="text-xs font-medium text-gray-600">{country.code}</span>
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-900">{country.name}</h3>
                    <p className="text-xs text-gray-500">Code: {country.code}</p>
                  </div>
                </div>
                <div className="text-right">
                  <span className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${
                    country.hagueConvention 
                      ? 'bg-green-100 text-green-800' 
                      : 'bg-red-100 text-red-800'
                  }`}>
                    {country.hagueConvention ? 'Hague' : 'Non-Hague'}
                  </span>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {filteredCountries.length === 0 && (
          <Card className="p-8">
            <div className="text-center text-gray-500">
              <i className="ri-search-line text-4xl mb-2"></i>
              <p className="text-sm">No countries found</p>
              <p className="text-xs text-gray-400 mt-1">Try adjusting your search or filter</p>
            </div>
          </Card>
        )}
      </div>

      <Navigation />
    </div>
  );
}
